import * as React from 'react';
import {connect} from 'react-redux';
import {Router, Route, Switch, Redirect} from 'react-router-dom';

import history from '../history';
import AppContainer from './config-studio-index/AppContainer';
import Login from './config-studio-index/Login';
import UnifiedLogin from './config-studio-index/UnifiedLogin';
import ConfigEditor from './config-editor';
import ConfigTester from './config-tester';

interface StateProps {
	isLoggedIn: boolean;
}

function mapStateToProps({global}: StudioState): StateProps {
	return {
		isLoggedIn: !!global.user.authorization,
	};
}

class App extends React.Component<StateProps, {}> {

	public render() {
		const { isLoggedIn } = this.props;
		return <Router history={history}>
			<AppContainer>
				<Switch>
					{!isLoggedIn && <Route exact path='/login' component={Login} />}
					{!isLoggedIn && <Route exact path='/unified-login' component={UnifiedLogin} />}
					{isLoggedIn && <Route exact path='/home' component={ConfigTester} />}
					{isLoggedIn && <Route exact path='/editor' component={ConfigEditor} />}
					{isLoggedIn && <Route exact path='/tester' component={ConfigTester} />}
					<Redirect to={this.getRedirectRoute()} />
				</Switch>
			</AppContainer>
		</Router>;
	}

	private getRedirectRoute() {
		const {isLoggedIn} = this.props;
		const {hash} = window.location;
		if (!isLoggedIn) {
			if (/^#\/unified-login/.test(hash)) {
				return '/unified-login';
			} else {
				return '/login';
			}
		} else if (/^#\/home/.test(hash)) {
			return '/home';
		} else if (/^#\/editor/.test(hash)) {
			return '/editor';
		} else if (/^#\/tester/.test(hash)) {
			return '/tester';
		} else {
			return '/home';
		}
	}

}

export default connect<StateProps, {}, {}>
	(mapStateToProps, null)(App);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/App.tsx